import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export const useHistoryListener = (callback: () => void) => {
  const history = useHistory();

  useEffect(() => history.listen(callback), [callback, history]);
};
